module.exports = __webpack_public_path__ + "static/img/0546_5.cc968e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0546_5.jpg
// module id = b53v
// module chunks = 1